export const KEY = 'app/office'
export const FETCH_OFFICES = `${KEY}-fetch`
export const CLEAR_OFFICES = `${KEY}-clear`
